import { render, staticRenderFns } from "./SolicitarCertificadoPage.vue?vue&type=template&id=e131e440&scoped=true&"
import script from "./SolicitarCertificadoPage.vue?vue&type=script&lang=js&"
export * from "./SolicitarCertificadoPage.vue?vue&type=script&lang=js&"
import style0 from "./SolicitarCertificadoPage.vue?vue&type=style&index=0&id=e131e440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e131e440",
  null
  
)

export default component.exports